<template>
    <modal :show.sync="showModal" >
        <h6 slot="header" class="modal-title">Nro de venta, Venta ID: {{venta_id}}</h6>
        <div class="container">
            <base-input 
                label="Número de venta:"
                v-model="nro_venta"
            >
            </base-input>
        </div>
        <template slot="footer">
            
            <base-button type="link" class="ml-auto" @click="sendForm">Aceptar y guardar</base-button>
        </template>
    </modal>
</template>

<script>

export default {
    components: {
        
    },
    data(){
        return {
            venta_id: undefined,
            showModal: false,
            nro_venta: undefined,
        }
    },
    methods: {
        fetchUrl(venta){
            var vm = this;
            this.axios({
                url: 'api/ventas/nro_venta?venta='+venta,
                method: 'GET',
            }).then( response => {
                vm.nro_venta = response.data;
                vm.showModal = true;
            }).catch( error => {
                console.log(error);
            });
        },
        actualizarTotalPaginacion(value){
            this.totalPaginacion = value;
        },
        sendForm()
        {
            var vm = this;
            this.axios({
                url: 'api/ventas/nro_venta',
                method: 'PUT',
                data: {
                    venta: this.venta_id,
                    nro_venta: this.nro_venta,
                }
            }).then( response => {
                vm.$notify({
                    message: 'Nro de venta ha sido actualizado correctamente',
                    type: 'success'
                })
                vm.showModal = false;
            }).catch( error => {

            });
        }
    },
    created()
    {
      this.$parent.$on('loadModalNroVenta', (venta_id) => { this.fetchUrl(venta_id); this.venta_id = venta_id } );
    },
}
</script>
<style lang="scss">
.pagination.pagination-sm{
    margin-bottom: 0.1rem;
}
</style>